export const images_swirl_white = require("./images/swirl_white.png");
export const illustrations = {
  banks: {
    transfer_bank: require("./ilustrations/transfer_bank.png"),
    transfer_globe: require("./ilustrations/transfer_overseas.png"),
    transfer_ewallet: require("./ilustrations/transfer_ewallet.png"),
  },
  logo: {
    flip: require("./ilustrations/logo_flip.png"),
    bank_bri: require("./ilustrations/logo_bank_bri.png"),
  },
  icon: {
    cashback: require("./ilustrations/cashback.png"),
  },
};
